module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "echarts-block"
  }, [_c('div', {
    staticClass: "echarts-contant",
    attrs: {
      "id": _vm.chart_id
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d91c5e1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Echarts.vue
// module id = 959
// module chunks = 1